import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './CommonContactUs.css';
import Footer from "../../Footer";
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import API from '../../../Utils/Api';
import {validatecontact} from '../../../Utils/validate';
import loader from '../../../assests/loader.gif';
import { gettoastwarning,gettoastsuccess } from '../../../Utils/Common';
import Topbar from "../../Topbar";

const CommonContactUs = () => {
    //const navigate = useNavigate();
    const [loading,setLoading] = useState(false);
    const [errors,setErrors] = useState({});
    const [inputs,setInputs] = useState({email:'',name:'',subject:'',message:''});

    useEffect(() => {
        document.title = `Contact Us | Local Bells`;
        document.getElementById('bodywrap').className = 'comcontact';
    }, []);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validatecontact(inputs);
     const noErrors = Object.keys(validationErrors).length === 0;
        setErrors({});
        setErrors(validationErrors);
        
        if(noErrors){
                setLoading(true);
            let formData = new FormData(); 
            Object.keys(inputs).forEach((key) => {
            formData.append(key, inputs[key]);
        });
            API.post('contact_us', formData)
              .then(response => {
              if(response.data.status === 0){
                //setError(response.data.message);
                setLoading(false); 
                gettoastwarning(response.data.message,'');
              }else{
                 setLoading(false);
                 gettoastsuccess(response.data.message,'/neighbour/contact-us');
              }                  
            }).catch(error => {
               setLoading(false);
               gettoastwarning("Something went wrong. Please try again later.",'');
                //setError("Something went wrong. Please try again later.");
            });
        }
    //navigate('/neighbour/login');
  };
/* Start Value set */
const handleInputChange = (event) => {
  event.persist();
  setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
}
/* End Value set */

    return (
        <>
            <Topbar />
            <section className="main-cont-box">
                <Container>
                    <Row className="justify-content-center">
                        {/*<NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />*/}
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            {/*<Header toggleSidebar={toggleSidebar} />*/}    
                            <div className='nei-cont'>
                                <div className=''>
                                    <Row>
                                        <Col md={8}>
                                            <div className='white-box help-box'>
                                                <h3>We're here to help</h3>
                                                <h6>If you have any questions, feedback, or support needs, feel free to send us a message below.</h6>
                                                <Form onSubmit={handleSubmit}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className='d-none'>Your Name</Form.Label>
                                                        <Form.Control type="text" placeholder="Your Name" name="name" onChange={handleInputChange} value={inputs.name} />
                                                        {errors.name && (<p className="text-danger">{errors.name}</p>)}
                                                    </Form.Group>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className='d-none'>Your Email</Form.Label>
                                                        <Form.Control type="text" placeholder="Your Email" name="email" onChange={handleInputChange} value={inputs.email} />
                                                        {errors.email && (<p className="text-danger">{errors.email}</p>)}
                                                    </Form.Group>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className='d-none'>Subject</Form.Label>
                                                        <Form.Control type="text" placeholder="Subject" name="subject" onChange={handleInputChange} value={inputs.subject} />
                                                        {errors.subject && (<p className="text-danger">{errors.subject}</p>)}
                                                    </Form.Group>                                                                                                        
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className='d-none'>Type your message</Form.Label>
                                                        <Form.Control as="textarea" rows={4} placeholder='Type your message' name="message" onChange={handleInputChange} value={inputs.message}/>
                                                        {errors.message && (<p className="text-danger">{errors.message}</p>)}
                                                    </Form.Group>
                                                    <Button type="submit" className='blue-btn'>Send message</Button>
                                                </Form>                                                
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className='white-box cnt-box'>
                                                <h3>Contact Us</h3>
                                                <div>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/email.webp'} className="img-fluid" alt="email"/>
                                                    <div>
                                                        <h6>Email</h6>
                                                        <h6>support@localbells.com</h6>
                                                    </div>
                                                </div>
                                                <div>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/mobile.webp'} className="img-fluid" alt="mobile"/>
                                                    <div>
                                                        <h6>Phone</h6>
                                                        <h6>+91 8484040933</h6>
                                                    </div>
                                                </div>
                                                <div className="d-none">
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/location.webp'} className="img-fluid" alt="location"/>
                                                    <div>
                                                        <h6>Address</h6>
                                                        <h6>Veeva Creatives, Nashik, India</h6>
                                                    </div>
                                                </div>                                                                                                
                                            </div>
                                        </Col>                                        
                                    </Row>
                                </div>
                                                                  
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer />
            {loading && (
               <div className="loadingClass">
                <img src={loader} alt="loader"/>
              </div>
               )} 
        </>
    )
}

export default CommonContactUs;


